import type { FaireProductEntity } from "../../entity_types/product";

export const p_9yfcf7eq73: FaireProductEntity = {
  token: "p_9yfcf7eq73",
  type: "product",
  name: "Vanilla Candy Cane - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/4a3a1a3b4b2cf5fd2ec8eecfdaf11a32382ccd1e9be0df7e5937b599c85d3258.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aeb63e66a016312b362eac5824934c9264c2c430babb9ba8459a979990a6382d.png"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND \n\nCreamy, cozy and minty-fresh, this joyful tea transports you to a dreamy winter wonderland. Energizing and antioxidant-rich black tea pairs up with fresh peppermint and vanilla bean for a superfood twist on Christmas candy cane. Pairs deliciously with a crackling fire, cozy socks and Hallmark holiday movies. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Drizzle with honey or maple syrup for a sweeter touch \n * Ice it: Steep it double strength and top with plenty of ice. Great with oat milk. \n * Cold-brew: Brew it overnight with cold water and add milk and honey. \n\nWhen to Steep:\n\n * As an afternoon treat without the sugar.\n * As a tea latte instead of your afternoon coffee. \n * When you are feeling under the weather. \n * As an after-dinner treat with honey and milk.\n\nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:46.901Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
